(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/jupiter/assets/javascripts/jupiter.js') >= 0) return;  svs.modules.push('/components/core/jupiter/assets/javascripts/jupiter.js'); 
var svs = svs || {};

svs.core = svs.core || {};

(function(svs) {
  'use strict';

  var apiUrl = svs.core.jupiter.data.url;

  svs.core.jupiter = (function() {
    var logger = new svs.core.log.Logger('component:core.jupiter'),
      nw,
      rpp,
      mrpp,
      iDiv,
      sessionTimeMs,
      realityCheckMsg;

    if (
      svs.core.config.data.svsconfig.env === 'development' &&
      Object.prototype.hasOwnProperty.call(svs.core.data, 'rpp')
    ) {
      nw = svs.core.data.rpp.nw || 0;
      rpp = svs.core.data.rpp.rpp || 0;
      mrpp = svs.core.data.rpp.mrpp || 0;
      iDiv = document.createElement('div');
      iDiv.id = 'jupitercounter';
      iDiv.style.height = '17px';
      iDiv.style.zIndex = '9999';
      iDiv.style.left = '0';
      iDiv.style.padding = '0 3px';
      iDiv.style.top = '0';
      iDiv.style.position = 'fixed';
      iDiv.style.display = 'none';
      iDiv.style.color = '#afafb3';
      iDiv.style.backgroundColor = 'rgba(0,0,0,0.5)';
      iDiv.style.display = 'block';
      document.getElementsByTagName('body')[0].appendChild(iDiv);
      iDiv.innerHTML = 'jp: ' + nw + ' (' + mrpp + ') / ' + rpp;
      iDiv.title =
        'Network round-trips (where of multifetch) / Total Jupiter executions';
    }
    if (svs && svs.core && svs.core.data) {
      sessionTimeMs = svs.core.data.sessionTimeMs;
      realityCheckMsg = svs.core.data.rcmsg;
      if (realityCheckMsg) {
        logger.debug(
          'Found rcmsg from server with id: ' + realityCheckMsg.messageId
        );
      }
    }
    return {
      parseErrorResponse: function(response) {
        var params;
        var jsonResp =
          response && response.responseJSON ? response.responseJSON : null;

        if (jsonResp && jsonResp.error) {
          if (jsonResp.error) {
            if (jsonResp.error.code) {
              params = {};
              params.code = jsonResp.error.code;
            }
            if (jsonResp.error.requestId) {
              params = params || {};
              params.reqId = jsonResp.error.requestId;
            }
            if (jsonResp.error.message) {
              params = params || {};
              params.message = decodeURI(jsonResp.error.message);
            }
          }
        } else if (jsonResp && jsonResp.status) {
          if (jsonResp.status.code) {
            params = {};
            params.code = jsonResp.status.code;
          }
          if (jsonResp.status.description) {
            params = params || {};
            params.description = jsonResp.status.description;
          }
          if (jsonResp.message) {
            params = params || {};
            params.message = jsonResp.message;
          }
        }

        return params;
      },
      url: function() {
        return apiUrl;
      },
      multiFetch: function(paths) {
        for (var i = 0; i < paths.length; i++) {
          paths[i] = encodeURIComponent(paths[i]);
        }
        return (
          this.url() + '/multifetch?urls=' + paths.join(encodeURIComponent('|'))
        );
      },

      call: function(options, successCallback, errorCallback) {
        var self = this;

        var doCall = function(options, successFunction, errorFunction) {
          var ajaxOpts = {
            type: options.method,
            url: self.url() + options.path,
            dataType: 'json',
            data: options.data,
            cache: false,
            timeout: svs.core.config.data.svsconfig.clientAjaxTimeout, 
            xhrFields: {
              withCredentials: true
            },
            success: successFunction,
            error: errorFunction,
            context: options.context
          };
          if (iDiv) {
            nw++;
            rpp += options.path.split('|').length;
            if (options.path.indexOf('multifetch') > -1) {
              mrpp++;
            }
            iDiv.innerHTML = 'jp: ' + nw + ' (' + mrpp + ') / ' + rpp;
          }
          if (options.ghost) {
            ajaxOpts.headers = ajaxOpts.headers || [];
            ajaxOpts.headers['X-Casper'] = 'true';
          } else {
            ajaxOpts.complete = function(xhr, status) {
              if (xhr && xhr.getResponseHeader('x-casper')) {
                setTimeout(haunt, 0, options);
              }
              if (options.complete) {
                options.complete(xhr, status);
              }
            };
          }
          if (options.method.toLowerCase() !== 'get') {
            if (options.data instanceof FormData) {
              ajaxOpts.contentType = false;
            } else {
              ajaxOpts.contentType = 'application/json';
              if (typeof options.data !== 'string') {
                ajaxOpts.data = JSON.stringify(options.data);
              }
            }
            ajaxOpts.processData = false;
            ajaxOpts.crossDomain = true;
          } else {
            ajaxOpts.contentType = 'text/plain';
          }
          return $.ajax(ajaxOpts);
        };

        var onSuccess = function(response, status, xhr) {
          logger.debug(
            'Jupiter call success ' + options.method + ' ' + options.path
          );
          svs.events.publish('/core/jupiter/response', xhr.status);
          sessionTimeMs =
            response.requestInfo && response.requestInfo.sessionTimeMs;
          realityCheckMsg = response.rcmsg ? response.rcmsg : undefined;
          if (sessionTimeMs) {
            svs.events.publish('/core/jupiter/sessionTimeMs', sessionTimeMs);
          }
          if (
            xhr.getResponseHeader('X-RC-Messageid') ||
            xhr.getResponseHeader('X-RC-Payload')
          ) {
            logger.debug(
              'Received rcmsg with id: ' +
                xhr.getResponseHeader('X-RC-Messageid')
            );
            realityCheckMsg = {
              messageId: xhr.getResponseHeader('X-RC-Messageid'),
              payload: xhr.getResponseHeader('X-RC-Payload')
            };
            svs.events.publish(
              '/componets/realitycheck/message',
              realityCheckMsg
            );
          }
          if (successCallback) {
            response = JSON.parse(JSON.stringify(response), function(
              key,
              value
            ) {
              if (key === 'sessionId' || key === 'deviceId') {
                return '[hidden]';
              }
              return value;
            });
            successCallback.call(options.context, response, status, xhr);
          }
        };

        var onError = function(xhr, status, err) {
          var logMsg =
            'Jupiter call failed ' +
            xhr.status +
            ' (' +
            options.method +
            ' ' +
            options.path +
            ')';
          if (!xhr.responseJSON) {
            if (err === '' && status === 'error' && xhr.status === 0) {
              logMsg += ', Potential network error';
            } else {
              logMsg += ', Message:' + err;
            }
            logMsg +=
              ', Status:' +
              status +
              ', XhrStatus:' +
              xhr.status +
              ', XhrText:' +
              xhr.responseText;
            if (xhr.status >= 300 && xhr.status < 500) {
              logger.info(logMsg);
            } else {
              logger.error(logMsg);
            }
            var customErrorObject = {
              error: { code: 666, message: 'Trinidad Error : ' + err }
            };
            xhr.responseJSON = customErrorObject;
            xhr.responseText = JSON.stringify(customErrorObject);
          } else {
            if (xhr.status >= 300 && xhr.status < 500) {
              logger.info(
                logMsg + ', Message:' + err,
                self.parseErrorResponse(xhr)
              );
            } else {
              logger.warn(
                logMsg + ', Message:' + err,
                self.parseErrorResponse(xhr)
              );
            }
          }
          svs.events.publish('/core/jupiter/response', xhr.status);
          if (errorCallback) {
            errorCallback.call(options.context, xhr, status, err);
          }
        };

        var onErrorExt = function(xhr, status, err) {
          var errCodeStr, errCode;
          switch (xhr.status) {
            case 400:
              if (xhr.responseJSON && xhr.responseJSON.error) {
                errCodeStr = String(xhr.responseJSON.error.code);
                errCode = parseInt(errCodeStr.replace(/\s/g, ''), 10);
                switch (errCode) {
                  case 3107: 
                    logger.info(
                      'Client tries to access protected path unauthorized in ASM, path: ' +
                        options.path
                    );
                    svs.core.userSession.logout(
                      svs.core.userSession.logoutReason.INVALID_SESSION
                    );
                    break;
                  case 100005: 
                    logger.info(
                      'Client tries to access protected path unauthorized, path: ' +
                        options.path
                    );
                    break;
                  default:
                    onError(xhr, status, err);
                }
              } else {
                onError(xhr, status, err);
              }
              break;
            case 401:
              logger.info('Client has invalid session, path: ' + options.path);
              svs.core.userSession.logout(
                svs.core.userSession.logoutReason.INVALID_SESSION
              );
              break;
            case 403:
              logger.info(
                'Client tries to access protected path unauthorized, path: ' +
                  options.path
              );
              onError(xhr, status, err);
              break;
            case 500:
              if (xhr.responseJSON && xhr.responseJSON.error) {
                errCodeStr = String(xhr.responseJSON.error.code);
                errCode = parseInt(errCodeStr.replace(/\s/g, ''), 10);
                switch (errCode) {
                  case 3107: 
                    logger.info(
                      'Client tries to access protected path unauthorized in ASM, path: ' +
                        options.path
                    );
                    svs.core.userSession.logout(
                      svs.core.userSession.logoutReason.INVALID_SESSION
                    );
                    break;
                  case 100005: 
                    logger.info(
                      'Client tries to access protected path unauthorized ASM, path: ' +
                        options.path
                    );
                    break;
                  default:
                    onError(xhr, status, err);
                }
              } else {
                onError(xhr, status, err);
              }
              break;
            default:
              onError(xhr, status, err);
          }
        };

        var haunt = function(options) {
          options.ghost = true;
          doCall(
            options,
            function(response, status) {
              logger.debug(
                'Received Ghost response. Status: ' +
                  status +
                  '. Uri: ' +
                  options.method +
                  ' ' +
                  options.path
              );
            },
            function(xhr, status) {
              logger.warn(
                'Received Ghost response with error. Status: ' +
                  status +
                  '. Uri: ' +
                  options.method +
                  ' ' +
                  options.path
              );
            }
          );
        };

        if (!Object.prototype.hasOwnProperty.call(options, 'useExtErrFunc')) {
          options.useExtErrFunc = true;
        }

        if (options.useExtErrFunc) {
          return doCall(options, onSuccess, onErrorExt);
        }
        return doCall(options, onSuccess, onError);

      },

      callParallel: function(paths, success, error, limit, executeError) {
        var self = this,
          responses = [],
          localPaths = paths || [];

        var noop = function() {};
        success = success || noop;
        error = error || noop;
        executeError = executeError !== false; 

        limit = limit || 10; 

        if (
          !localPaths.length ||
          typeof success !== 'function' ||
          typeof error !== 'function'
        ) {
          logger.debug('Invalid parameters.', localPaths, success, error);
          return;
        }

        this.eachLimit(
          localPaths,
          limit,
          function(path, callback) {
            self.call(
              {
                method: 'GET',
                path: path
              },
              function(response) {
                responses.push({
                  path: path,
                  data: response
                });

                callback();
              },
              function(xhr, status, err) {
                if (executeError) {
                  callback(xhr, status, err);
                } else {
                  callback();
                }
              }
            );
          },
          function(xhr, status, err) {
            if (
              executeError &&
              xhr &&
              xhr.responseJSON &&
              xhr.responseJSON.error
            ) {
              error(xhr, status, err);
            } else {
              success(responses);
            }
          }
        );
      },

      eachLimit: function(arr, limit, iterator, callback) {
        callback = callback || function() {};
        if (!arr.length || limit <= 0) {
          return callback();
        }
        var completed = 0;
        var started = 0;
        var running = 0;

        (function replenish() {
          if (completed >= arr.length) {
            return callback();
          }

          function iteratorFn(xhr, status, err) {
            if (err) {
              callback(xhr, status, err);
              callback = function() {};
            } else {
              completed += 1;
              running -= 1;
              if (completed >= arr.length) {
                callback();
              } else {
                replenish();
              }
            }
          }

          while (running <= limit && started < arr.length) {
            started += 1;
            running += 1;
            iterator(arr[started - 1], iteratorFn);
          }
        })();
      },
      getSessionTimeMs: function() {
        return sessionTimeMs;
      },
      getRealityCheckMsg: function() {
        return realityCheckMsg;
      }
    };
  })();

  ['get', 'post', 'delete', 'put'].forEach(function(method) {
    svs.core.jupiter[method] = function(
      options,
      successCallback,
      errorCallback
    ) {
      if (typeof options === 'object') {
        options.method = method;
      }

      if (typeof options === 'string') {
        options = {
          path: options,
          method: method
        };
      } else if (method === 'get' && Array.isArray(options)) {
        options = {
          path: '/multifetch?urls=' + options.join('|'),
          method: method
        };
      }

      return this.call(options, successCallback, errorCallback);
    };
  });
})(svs);

 })(window);